import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { fbAdsSetup } from "@/services/api/cresivoxServer";


import { REDUCER_NAME, IFacebookAdCreateDTO } from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);


// export const addfacebookAds = createAsyncThunk<
// 	iGenericResponse<any | null> | null,
// 	IFacebookAdCreateDTO,
// 	{
// 		rejectValue: iStateMessage;
// 	}
// >(
// 	curriedGetThunkName("addfacebookAds"),
// 	// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
// 	async (payload, { rejectWithValue }) => {
// 		try {
// 			const response = await fbAdsSetup.createfacebookAds(payload as any);

// 			if (!response) {
// 				return rejectWithValue({ message: "No response received" });
// 			}
		
// 			console.log("dasdadasdsadadas",response)

// 			if (response) {
// 				const {httpStatusCode, data, message} = response;
// 				switch (httpStatusCode) {
// 					case httpStatusCodes.SUCCESS_OK: {
// 						if (data && data.data) {
// 							return {
// 								data: {
// 									orders: data.data,
// 									message,
// 								}
// 							};
// 						} else {
// 							return rejectWithValue({
// 								httpStatusCode,
// 								message,
// 							});
// 						}
// 					}
// 					default: {
// 						return rejectWithValue({
// 							httpStatusCode,
// 							message,
// 						});
// 					}
// 				}
// 			} 
// 			else {
// 				return rejectWithValue({
// 					message: "No response received",
// 				});
// 			}
// 		} catch (error) {
// 			console.log("🚀 ~ error:", error);
// 			return rejectWithValue({
// 				message: "Something went wrong",
// 			});
// 		}
// 	},
// );

export const addfacebookAds = createAsyncThunk<
  any,
  IFacebookAdCreateDTO,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("addfacebookAds"),
  async (payload, { rejectWithValue }) => {
    try {
      const response = await fbAdsSetup.createfacebookAds(payload);

      if (!response) {
        return rejectWithValue({ message: "No response received" });
      }

    //   console.log("🔥 FIXED RESPONSE:", response);

      const { httpStatusCode, data, message } = response;

	  //@ts-ignore
      if (httpStatusCode === 200 && data?.isSuccess === true) {
        const adId = data?.responseBody?.data?.id;

        return {
          data: {
            id: adId,
          },
          message: "Ad created successfully",
        };
      }

      return rejectWithValue({
        httpStatusCode,
        message: data?.responseBody?.error?.message || message,
      });

    } catch (error) {

      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);



export const getfacebookAdsList = createAsyncThunk<
	iGenericResponse<any | null> | null,
	void,
	{
		rejectValue: iStateMessage;
	}
>(
	curriedGetThunkName("getfacebookAdsList"),
	// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
	async (arg, { rejectWithValue }) => {
		try {
			const response = await fbAdsSetup.getfacebookAds();
			if (response) {
				const { httpStatusCode, data, message } = response;

				switch (httpStatusCode) {
					case httpStatusCodes.SUCCESS_OK: {
						if (data && data.data) {
							return {
								data: {
									httpStatusCode,
									data: data.data,
									message,
								}
							};
						} else {
							return rejectWithValue({
								httpStatusCode,
								message,
							});
						}
					}
					default: {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
			} else {
				return rejectWithValue({
					message: "No response received",
				});
			}
		} catch (error) {
			return rejectWithValue({
				message: "Something went wrong",
			});
		}
	},
);








